import React, { PureComponent } from 'react'

import SubscriptionLogo from 'client/bookmate/blocks/subscription-logo'
import { StyledBadge } from 'client/shared/blocks/badge'

import './non-recurrent-subscription-card.styl'

import { NonRecurrentSubscription } from 'client/shared/types/subscription'

type Props = {
  subscription: NonRecurrentSubscription
}

class NonRecurrentSubscriptionCard extends PureComponent<Props> {
  render(): JSX.Element {
    return (
      <div className="non-recurrent-subscription-card">
        {this.renderTop()}
        <div className="non-recurrent-subscription-card__description">
          {this.props.subscription.description}
        </div>
      </div>
    )
  }

  renderTop() {
    return (
      <div className="non-recurrent-subscription-card__identity">
        {this.renderLabels()}
        {this.renderSubscriptionLogo()}
      </div>
    )
  }

  renderLabels() {
    const labels = this.props.subscription.labels.map((label, index) => (
      <StyledBadge key={index} color={label.color}>
        {label.name}
      </StyledBadge>
    ))

    return (
      <div className="non-recurrent-subscription-card__labels">{labels}</div>
    )
  }

  renderSubscriptionLogo() {
    // currently, all our non-recurrent subscriptions are promo-subscriptions
    return <SubscriptionLogo system="promo" />
  }
}

export default NonRecurrentSubscriptionCard
